import { render } from "./PaymentView.vue?vue&type=template&id=1df05d55"
import script from "./PaymentView.vue?vue&type=script&lang=js"
export * from "./PaymentView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__